<module-groups-listing [addEntity]="newInstitutionGroup"
                       [dataSource]="dataSource"
                       [deleteEntity]="deleteInstitutionGroup"
                       [displayedColumns]="displayedColumns"
                       [displayedFilters]="displayedFilters"
                       fxFlex
                       fxLayout="column"
></module-groups-listing>
